import { Form, TextField } from '@calendly/form';
import { object, string } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { useMeetingTypesPath } from 'hooks/use_meeting_types_path';
import { useDeclineRequestToJoinOrganizationMutation, useGetOrganizationInvitationQuery } from '../api';
const styledContainerCss = "s1ohjs07";
const StyledContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledContainerCss, props.className)} />;
});
const styledSheetIsPhoneCss = "s2h4dq0";
const styledSheetCss = "szytyxt";
const StyledSheet = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(styledSheetCss, {
    [styledSheetIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledTextFieldCss = "s1xk1wke";
const StyledTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextFieldCss, props.className)} />);
const buildValidationSchema = () => object({
  message: string().trim().max(255)
});
const MissingOrganizationComponent = () => {
  const meetingTypesPath = useMeetingTypesPath();
  return <StyledContainer>
      <HeadingText level={1} size="medium">
        {I18n.t('publisher.organization.join.decline.missing.title')}
      </HeadingText>
      <BodyText>
        {I18n.t('publisher.organization.join.decline.missing.description')}
      </BodyText>
      <Button as={RouterLink} type="submit" size="small" to={meetingTypesPath}>
        {I18n.t('publisher.organization.join.decline.missing.button')}
      </Button>
    </StyledContainer>;
};
export const DeclineRequestToJoin = () => {
  const {
    id
  } = useParams();
  const [decline, {
    isLoading,
    isSuccess
  }] = useDeclineRequestToJoinOrganizationMutation();
  const {
    isFetching,
    error,
    data: {
      name,
      email
    } = {}
  } = useGetOrganizationInvitationQuery({
    id
  });
  const meetingTypesPath = useMeetingTypesPath();
  useEffect(() => {
    if (isSuccess) window.location.href = meetingTypesPath;
  }, [isSuccess, meetingTypesPath]);
  const onSubmit = ({
    message
  }) => {
    decline({
      id,
      message
    });
  };
  if (isFetching) {
    return null;
  }
  if (error) {
    return <MissingOrganizationComponent />;
  }
  return <StyledContainer>
      <StyledSheet>
        <HeadingText level={1} size="medium">
          {I18n.t('publisher.organization.join.decline.title', {
          name
        })}
        </HeadingText>
        <BodyText>
          {I18n.t('publisher.organization.join.decline.description', {
          email
        })}
        </BodyText>
        <Form initialValues={{
        message: ''
      }} validationSchema={buildValidationSchema()} onSubmit={onSubmit}>
          <StyledTextField type="textarea" name="message" label={I18n.t('publisher.organization.join.decline.label')} />
          <Grid>
            <GridItem size={6} sizeMobile={12}>
              <Button as={RouterLink} size="small" decoration="secondary-outline" wide to={meetingTypesPath}>
                {I18n.t('publisher.action.cancel')}
              </Button>
            </GridItem>
            <GridItem size={6} sizeMobile={12}>
              <Button type="submit" size="small" loading={isLoading || isSuccess} wide>
                {I18n.t('publisher.action.send')}
              </Button>
            </GridItem>
          </Grid>
        </Form>
      </StyledSheet>
    </StyledContainer>;
};

require("./decline-request-to-join.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./decline-request-to-join.js");